@if (initialized) {
    <div class="cn-expectation-trace">
        <p-accordion [value]="expanded ? '0' : null">
            <p-accordion-panel value="0">
                <p-accordion-header>
                    <span class="flex align-items-center gap-2">
                        <i class="fa-regular fa-diagram-subtask text-primary"></i>
                        <span class="font-medium">{{ title }}</span>
                        @if (netAmount != null) {
                            <span class="text-sm text-600">
                                netto {{ netAmount | currency:'EUR':'symbol':'1.2-2':'de' }}
                            </span>
                        }
                    </span>
                </p-accordion-header>
                <p-accordion-content>

                    @if (parseError) {
                        <p-message severity="error" class="block mb-2"
                                   text="Die Herleitung konnte nicht gelesen werden.">
                        </p-message>
                    }

                    @if (!hasSteps() && !parseError) {
                        <div class="text-600 p-3 text-center">
                            Keine Herleitung verfügbar.
                        </div>
                    }

                    @if (hasSteps()) {

                        @if (hasSummary()) {
                            <div class="flex align-items-start gap-2 mb-3 p-3 surface-100 border-round">
                                <i class="fa-regular fa-lightbulb text-primary mt-1"></i>
                                <div>
                                    <div class="font-bold mb-1">Warum dieser Betrag?</div>
                                    <div class="text-700">{{ resolvedSummary }}</div>
                                </div>
                            </div>
                        }

                        <p-table [value]="parsedSteps" styleClass="p-datatable-sm">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Schritt</th>
                                    <th class="text-right">Eingang</th>
                                    <th class="text-center">Faktor / Operation</th>
                                    <th class="text-right">Ergebnis</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-step>
                                <tr>
                                    <td>
                                        <div class="font-medium">{{ stepLabel(step) }}</div>
                                        @if (step.explanation) {
                                            <div class="text-sm text-600 mt-1">{{ step.explanation }}</div>
                                        }
                                    </td>
                                    <td class="text-right">
                                        @if (step.inputValue != null) {
                                            {{ step.inputValue | currency:'EUR':'symbol':'1.2-2':'de' }}
                                        } @else {
                                            <span class="text-500">–</span>
                                        }
                                    </td>
                                    <td class="text-center">
                                        @if (operationLabel(step)) {
                                            <span class="text-600">{{ operationLabel(step) }}</span>
                                        }
                                        @if (operationLabel(step) && step.factor != null) {
                                            <span>&nbsp;</span>
                                        }
                                        @if (step.factor != null) {
                                            <span class="font-semibold">{{ step.factor | number:'1.0-4':'de' }}</span>
                                        }
                                        @if (!operationLabel(step) && step.factor == null) {
                                            <span class="text-500">–</span>
                                        }
                                    </td>
                                    <td class="text-right">
                                        @if (step.outputValue != null) {
                                            <span class="font-medium">
                                                {{ step.outputValue | currency:'EUR':'symbol':'1.2-2':'de' }}
                                            </span>
                                        } @else {
                                            <span class="text-500">–</span>
                                        }
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        @if (grossAmount != null || netAmount != null) {
                            <div class="flex justify-content-end gap-4 mt-3 pt-2 border-top-1 surface-border">
                                @if (grossAmount != null) {
                                    <div class="text-right">
                                        <div class="text-xs text-600">Brutto</div>
                                        <div class="font-semibold">
                                            {{ grossAmount | currency:'EUR':'symbol':'1.2-2':'de' }}
                                        </div>
                                    </div>
                                }
                                @if (netAmount != null) {
                                    <div class="text-right">
                                        <div class="text-xs text-600">Netto (nach Storno)</div>
                                        <div class="font-semibold text-primary">
                                            {{ netAmount | currency:'EUR':'symbol':'1.2-2':'de' }}
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    }

                </p-accordion-content>
            </p-accordion-panel>
        </p-accordion>
    </div>
}
